// hooks/useBreadcrumb.ts

"use client"

import { useMemo } from "react"
import { usePathname } from "next/navigation"

type SidebarItem = {
  title: string
  href: string
}

type SidebarItems = {
  [category: string]: SidebarItem[]
}

export function useBreadcrumb(items: SidebarItems) {
  const pathname = usePathname()

  const breadcrumbs = useMemo(() => {
    const pathSegments = pathname.split("/").filter((segment) => segment)
    const breadcrumbList = []

    let accumulatedPath = ""
    for (let i = 0; i < pathSegments.length; i++) {
      accumulatedPath += `/${pathSegments[i]}`
      let title = pathSegments[i]

      // itemsからタイトルを取得
      const found = Object.values(items)
        .flat()
        .find((item) => item.href === accumulatedPath)
      if (found) {
        title = found.title
      }

      breadcrumbList.push({
        href: accumulatedPath,
        title,
      })
    }

    return [{ href: "/", title: "ホーム" }, ...breadcrumbList]
  }, [pathname, items])

  return breadcrumbs
}
